import { Switch } from '@mui/material';
import type { ChangeEvent, PropsWithChildren } from 'react';
import React from 'react';

type ChargeEditDrawerProductSettingsProps = PropsWithChildren<{
  label: React.ReactNode;
  isChecked: boolean;
  handleOnChecked: (checked: boolean) => void;
}>;

export const ChargeEditDrawerProductSettings: React.FC<ChargeEditDrawerProductSettingsProps> = ({ label, isChecked, handleOnChecked, children }) => {
  return (
    <div className="flex flex-col gap-y-2">
      <div className="flex items-center gap-x-2">
        <Switch
          checked={isChecked}
          onChange={(_event: ChangeEvent<HTMLInputElement>, checked: boolean) => handleOnChecked(checked)}
        />
        <label>{ label }</label>
      </div>

      {isChecked && (
        children
      )}
    </div>
  );
};